import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';

const locationsApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const searchAddress = (q: string): Promise<AxiosResponse> => {
  return request({
    options: {
      url: `${locationsApiBaseUrl}/address-search`,
      method: 'GET',
      params: {
        q,
        type: 'cities',
      },
    },
  });
};

export const locationClient = {
  searchAddress,
};
